module.exports = __webpack_public_path__ + "static/media/no_journey.82a80dee.png";